import { MaritalStatuses } from '../../../../global/constants/lists';
import { CoveragePerson } from '../../../arc/features/new-hire-enrollment/enrollment/models/coverage-models';
import { Dependent, Dependents } from '../dependents/dependents-model';
import { Spouse } from './relationships-model';

export const getCurrentSpouse = (spouses: Spouse[]): Spouse => {
	return spouses?.filter(s => !s.end_date)[0];
};

export const getPreviousSpouses = (spouses: Spouse[]): Spouse[] => {
	return spouses?.filter(s => !!s.end_date);
};

export const getLastWidowedSpouse = (spouses: Spouse[]): Spouse => {
	return spouses?.filter(s => !!s.end_date && s.marriage_end_reason?.toLowerCase().includes('deceased'))
		?.sort((a: Dependent, b: Dependent) => new Date(b.end_date).getTime() - new Date(a.end_date).getTime())[0];
};

export const getLastDivorcedSpouse = (spouses: Spouse[]): Spouse => {
	return spouses?.filter(s => !!s.end_date && !s.marriage_end_reason?.toLowerCase().includes('deceased'))
		?.sort((a: Dependent, b: Dependent) => new Date(b.end_date).getTime() - new Date(a.end_date).getTime())[0];
};

export const determineCurrentSpouse = (maritalStatus: MaritalStatuses, spouses: Spouse[]) => {
	switch (maritalStatus) {
		case MaritalStatuses.Single:
		case MaritalStatuses.Married:
			return getCurrentSpouse(spouses);
		case MaritalStatuses.Divorced:
			return getLastDivorcedSpouse(spouses);
			break;
		case MaritalStatuses.Widowed:
			return getLastWidowedSpouse(spouses);
			break;
		default:
			return getCurrentSpouse(spouses);
	}
};

export const convertDependentToCoveragePerson = (dependent: Dependent): CoveragePerson => {
	return {
		guid: dependent._guid || null,
		disabled_child_indicator: null,
		first_name: dependent.first_name || '',
		middle_name: dependent.person.middle_name || '',
		last_name: dependent.last_name || '',
		suffix: null,
		relationship: null,
		relationship_start_date: dependent.start_date || null,
		age: null,
	};
};

export const convertDependentsToCoveragePersons = (dependents: Dependents): CoveragePerson[] => {
	const children = dependents.children || [];
	const domesticPartners = dependents.domesticPartners || [];

	const coveragePersons: CoveragePerson[] = [
		...children.map(convertDependentToCoveragePerson),
		...domesticPartners.map(convertDependentToCoveragePerson),
	];

	return coveragePersons;
};


export const getCurrentDomesticPartner = (domesticPartners: Dependent[]): Dependent => {
	const withEndDates = domesticPartners?.filter(d => d.end_date);
	return domesticPartners?.filter(d => !d.end_date && !withEndDates.find(dEnd => dEnd?.person_guid === d?.person_guid))[0];
};

export const getPreviousDomesticPartner = (domesticPartners: Dependent[]): Dependent[] => {
	return domesticPartners?.filter(d => !!d.end_date);
};
